/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
var ViewModel = function (options) {
  this.options = options || ({});
  this.scope = ko.observable({
    campaignId: this.options.campaignId,
    adGroupId: this.options.adgroupId,
    campaignName: this.options.campaignName,
    adGroupName: this.options.adGroupName
  });
  this.scopes = ko.observableArray();
  if (this.options.campaignId || this.options.adgroupId) {
    this.scopes.push(this.scope());
  }
  this.selectedExtensions = ko.observableArray([]);
  this.originalIds = [];
  this.maximumSelectionAlertString = ko.observable('');
  this.successfulAssociationsLabel = ko.observable('');
  this.failedAssociationsLabel = ko.observable('');
  this.updateInlineAlertString();
  this.showEditor = ko.observable(this.options.showEditor);
  this.showBoxList = ko.observable(this.options.showBoxList);
  this.showEditor.subscribe((function () {
    this.failedAssociationsLabel('');
  }).bind(this));
  ko_schema.properties(this);
  this.isAssociationChanged = ko.computed((function () {
    return !this.changes().isEmpty;
  }).bind(this));
  this.shouldShowMultiAssetWarning = ko.observable(false);
  this.sourceItemsString = this.options.i18n.get(this.options.i18nKeys.library_title);
  this.selectedItemsString = this.options.i18n.get(this.options.i18nKeys.selected_title);
  this.filterWatermarkString = this.options.i18n.get(this.options.i18nKeys.filter_watermark);
  this.filterAriaLabelString = this.options.i18n.get(this.options.i18nKeys.search_for).replace('{0}', this.options.i18n.get(this.options.i18nKeys.library_title).toLowerCase());
  this.maxSelectedItemsString = this.options.maxSelectedItemsCount > 0 ? this.options.i18n.get('AdExtensions_Max_Select_Count_New', {
    count: this.options.maxSelectedItemsCount
  }) : '';
};
ViewModel.prototype.setLoadedSelection = function (selected) {
  this.originalIds = _.pluck(selected, this.options.idField);
  this.selectedExtensions(selected);
};
ViewModel.prototype.changes = function () {
  var selectedIds = _.pluck(this.selectedExtensions(), this.options.idField), added = _.difference(selectedIds, this.originalIds), removed = _.difference(this.originalIds, selectedIds);
  return {
    added: added,
    removed: removed,
    isEmpty: !added.length && !removed.length
  };
};
ViewModel.prototype.updateInlineAlertString = function () {
  if (_.isFunction(this.options.getMaximumSelectionAlertString) && !_.isEmpty(this.scope())) {
    this.maximumSelectionAlertString(this.options.getMaximumSelectionAlertString(this.scope().campaignName, this.scope().adGroupName));
  }
};
ViewModel.prototype.clearOriginalIds = function () {
  this.originalIds = [];
};
ViewModel.prototype.handleDelete = function (extension) {
  this.selectedExtensions.deselectItem(extension);
  this.selectedExtensions.refreshSource();
  this.originalIds = _.reject(this.originalIds, function (itemId) {
    return itemId === extension[this.options.idField];
  }, this);
};
ViewModel.prototype.handleCreate = function (extension) {
  this.selectedExtensions.push(extension);
  this.selectedExtensions.refreshSource();
};
ViewModel.prototype.handleUpdate = function (extension) {
  this.selectedExtensions.refreshItem(extension);
  this.selectedExtensions.refreshSource();
  var index = _.findIndex(this.selectedExtensions(), function (item) {
    return item[this.options.idField] === extension[this.options.idField];
  }, this);
  this.selectedExtensions()[index] = extension;
};
ViewModel.prototype.handleRemovedIds = function (removedIds) {
  this.originalIds = _.difference(this.originalIds, removedIds);
};
ViewModel.prototype.handleSave = function () {
  this.originalIds = _.pluck(this.selectedExtensions(), this.options.idField);
};
export default ViewModel;

